export enum ETypeForms {
  AdminUser = 'user',
}
